import { render, staticRenderFns } from "./ReleaseDetails.vue?vue&type=template&id=2fd7cfec&"
import script from "./ReleaseDetails.vue?vue&type=script&lang=js&"
export * from "./ReleaseDetails.vue?vue&type=script&lang=js&"
import style0 from "./ReleaseDetails.vue?vue&type=style&index=0&id=2fd7cfec&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports